/* istanbul ignore next */
const ACTIONS = {
    SET_BUSINESS_MODEL_CHOICE: 'SET_BUSINESS_MODEL_CHOICE',
    GET_ADVERTISER_BUSINESS_MODEL: 'GET_ADVERTISER_BUSINESS_MODEL',
    GET_ADVERTISER_BUSINESS_MODEL_SUCCESS: 'GET_ADVERTISER_BUSINESS_MODEL_SUCCESS',
    BUSINESS_MODEL_SERVICE_ERROR: 'BUSINESS_MODEL_SERVICE_ERROR',
    TOGGLE_BUSINESS_MODEL_CONTINUE_BUTTON: 'TOGGLE_BUSINESS_MODEL_CONTINUE_BUTTON',
    PRE_POPULATE_LOCAL_STATE_BUSINESS_MODEL: 'PRE_POPULATE_LOCAL_STATE_BUSINESS_MODEL',
    SUBMIT_BUSINESS_MODEL: 'SUBMIT_BUSINESS_MODEL',
    SUBMIT_BUSINESS_MODEL_SUCCESS: 'SUBMIT_BUSINESS_MODEL_SUCCESS',
    GET_PREFERRED_BUSINESS_MODEL: 'GET_PREFERRED_BUSINESS_MODEL',
    GET_PREFERRED_BUSINESS_MODEL_SUCCESS: 'GET_PREFERRED_BUSINESS_MODEL_SUCCESS'
};
/* istanbul ignore next */
const ACTION_CREATORS = {
    setBusinessModelChoice(businessModelChoice) {
        return {
            type: ACTIONS.SET_BUSINESS_MODEL_CHOICE,
            payload: {
                businessModelChoice
            }
        };
    },

    getAdvertiserBusinessModel() {
        return {
            type: ACTIONS.GET_ADVERTISER_BUSINESS_MODEL
        };
    },

    getAdvertiserBusinessModelSuccess(advertiserBusinessModel) {
        return {
            type: ACTIONS.GET_ADVERTISER_BUSINESS_MODEL_SUCCESS,
            payload: {
                advertiserBusinessModel
            }
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.BUSINESS_MODEL_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    },

    toggleContinueButtonView() {
        return {
            type: ACTIONS.TOGGLE_BUSINESS_MODEL_CONTINUE_BUTTON
        };
    },

    prePopulateLocalState(publicUuid) {
        return {
            type: ACTIONS.PRE_POPULATE_LOCAL_STATE_BUSINESS_MODEL,
            payload: {
                publicUuid
            }
        };
    },

    submitBusinessModel(businessModelChoice) {
        return {
            type: ACTIONS.SUBMIT_BUSINESS_MODEL,
            payload: {
                businessModelChoice
            }
        };
    },

    submitBusinessModelSuccess() {
        return {
            type: ACTIONS.SUBMIT_BUSINESS_MODEL_SUCCESS
        };
    },

    getPreferredBusinessModel(systemId, pmType) {
        return {
            type: ACTIONS.GET_PREFERRED_BUSINESS_MODEL,
            payload : {
                systemId,
                pmType
            }
        };
    },

    getPreferredBusinessModelSuccess(businessModel) {
        return {
            type: ACTIONS.GET_PREFERRED_BUSINESS_MODEL_SUCCESS,
            payload : {
                businessModel
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
